import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { dateTimeSchema } from '../frameworks/entry.js';
import { currencySchema } from '../lib/entry.js';
import { productSchema } from '../product/entry.js';

export const wagerRefundsSchema = z.object({
  amount: currencySchema,
  drawNumber: drawNumberSchema,
  productId: productSchema,
  productName: z.string(),
  time: dateTimeSchema,
});
